import BachelorInAiComponents from "../components/BachelorInAiComponents";

function BachelorInAi() {
  return (
    <>
      <BachelorInAiComponents />
    </>
  );
}

export default BachelorInAi;
